import { render, staticRenderFns } from "./DesktopMenuNextMatches.vue?vue&type=template&id=6b0b2ced&scoped=true&"
import script from "./DesktopMenuNextMatches.vue?vue&type=script&lang=js&"
export * from "./DesktopMenuNextMatches.vue?vue&type=script&lang=js&"
import style0 from "./DesktopMenuNextMatches.vue?vue&type=style&index=0&id=6b0b2ced&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0b2ced",
  null
  
)

export default component.exports